module.exports = __webpack_public_path__ + "img/sup_deposit_crypto9.7f46b836.jpg";